// removed by extract-text-webpack-plugin
module.exports = {"inputQuantityWrap":"qempo_InputQuantity_inputQuantityWrap-6t4HKcG","disableLess":"qempo_InputQuantity_disableLess-1czM69z","disableMore":"qempo_InputQuantity_disableMore-2egXhp9"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/InputQuantity/InputQuantity.scss
// module id = 1630
// module chunks = 0